import {
  getLibraryAssetByKey,
  getLibraryAssetKey,
  LIBRARY_ROBOTS,
  LIBRARY_ATTACHMENTS,
  LIBRARY_OBJECTS,
} from "../libraryCatalog";

const findLibraryAsset = (folder, id) =>
  getLibraryAssetByKey(
    getLibraryAssetKey(
      [...LIBRARY_ROBOTS, ...LIBRARY_ATTACHMENTS, ...LIBRARY_OBJECTS].find(
        (asset) => asset.folder === folder && asset.id === id
      ) || {
        folder,
        id,
      }
    )
  );

export const ur5eAsset = findLibraryAsset("robots", "ur5e");
export const pandaAsset = findLibraryAsset("robots", "franka_emika_panda");
export const trossenAsset = findLibraryAsset("robots", "trossen_wx250s");
export const robotiq2f85Asset = findLibraryAsset("attachments", "robotiq_2f85");
export const shadowHandAsset = findLibraryAsset("attachments", "shadow_hand");
export const trayAsset = findLibraryAsset("objects", "tray");
export const cubeAsset = findLibraryAsset("objects", "cube");
export const eggAsset = findLibraryAsset("objects", "egg");

/** Preset-only: same MJCF as the library Spot "+ arm" variant, not a separate library row. */
export const spotArmPresetAsset = Object.freeze({
  folder: "robots",
  id: "boston_dynamics_spot",
  source: "critter-assets",
  xmlFilename: "spot_arm.xml",
  name: "Boston Dynamics Spot (+ arm)",
  category: "robot",
});
